import { render } from "./ProjectsView.vue?vue&type=template&id=8fbe1c40&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=8fbe1c40&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbe1c40"]])

export default __exports__